import { cn } from '../lib/cn';

export interface ProgressRingProps {
  value: number;            // 0–100
  size?: number;            // px, default 88
  label?: string;           // overrides the "NN%" center text
  className?: string;
}

export function ProgressRing({ value, size = 88, label, className }: ProgressRingProps) {
  const pct = Math.max(0, Math.min(100, Math.round(value)));
  // Scale the ring thickness and label with size so the percentage never
  // overflows at small sizes (e.g. the lesson rail's 48px ring). At the
  // default 88px this reproduces the previous look (ring 11px, inner 66px).
  const ring = Math.max(4, Math.round(size * 0.125));
  const inner = size - ring * 2;
  const fontSize = Math.max(9, Math.round(size * 0.2));
  return (
    <div
      role="progressbar"
      aria-valuenow={pct}
      aria-valuemin={0}
      aria-valuemax={100}
      className={cn('relative grid place-items-center', className)}
      style={{
        width: size, height: size, borderRadius: '50%',
        background: `conic-gradient(hsl(22 93% 46%) ${pct}%, hsl(214 32% 91%) 0)`,
      }}
    >
      <div
        className="grid place-items-center rounded-full bg-card text-center"
        style={{ width: inner, height: inner }}
      >
        <span className="font-heading font-bold leading-none" style={{ fontSize }}>{label ?? `${pct}%`}</span>
      </div>
    </div>
  );
}
